<template>
  <BaseDialog
    v-model="showDialog"
    title="Status"
    subtitle="Status på opplasting av filer"
    dialogIcon="mdi-progress-upload"
    scrollable
  >
    <template v-slot>
      <v-list v-if="statusList.length > 0" three-line color="cardSurface">
        <span v-for="(status, index) in statusList" :key="index">
          <v-list-item>
            <v-list-item-icon>
              <v-icon :color="status.status ? 'success' : 'error'">
                {{ status.status ? "mdi-check-circle" : "mdi-close-circle" }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>{{ status.fileName }}</v-list-item-subtitle>
              <v-list-item-title class="fixTitle">{{
                status.message
              }}</v-list-item-title>
              <!-- <v-list-item-subtitle>{{ status.message }}</v-list-item-subtitle> -->
              <v-list-item-subtitle>
                Lastet opp: {{ status.status ? "Ja" : "Nei" }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="statusList.length !== index + 1"></v-divider>
        </span>
      </v-list>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    statusList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
  },
});
</script>

<style lang="scss" scoped>
.fixTitle {
  white-space: initial;
}
</style>
